// Supabase REST(PostgREST)로 RPC만 호출합니다. 공개(publishable) 키만 쓰고, 테이블은 RLS로 읽기 전용입니다.
// supabase-js 전체를 묶지 않아 번들이 가볍습니다.
import { cached } from './cache';

const url = process.env.REACT_APP_SUPABASE_URL?.replace(/\/$/, '');
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const supabaseConfigured = Boolean(url && key);

async function post(name, params) {
  if (!supabaseConfigured) throw new Error('REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_PUBLISHABLE_KEY가 설정되지 않았습니다');
  const response = await fetch(`${url}/rest/v1/rpc/${name}`, {
    method: 'POST',
    headers: { apikey: key, 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) throw new Error(body?.message || `Supabase HTTP ${response.status}`);
  return body;
}

// ttl(ms) 동안 같은 호출 결과를 재사용합니다. 금리는 하루 한 번, 지점은 1년 단위로 바뀝니다.
export function rpc(name, params, ttl = 10 * 60 * 1000) {
  return cached(`${name}:${JSON.stringify(params)}`, ttl, () => post(name, params));
}
